export const CanvasHelper = {
  drawImage: (
    canvas: HTMLCanvasElement,
    blob: Blob,
    resize = false,
    params = [0, 0]
  ): Promise<void> => {
    const url = URL.createObjectURL(blob);
    const context = canvas.getContext('2d');
    return new Promise(resolve => {
      const image = new Image();
      image.onload = () => {
        // Draw image
        if (!resize) {
          canvas.width = image.width;
          canvas.height = image.height;
        }
        // @ts-ignore
        context.drawImage(image, ...params);
        resolve();
      };
      image.src = url;
    });
  },

  drawRectangle: (
    canvas: HTMLCanvasElement,
    x: number,
    y: number,
    w: number,
    h: number
  ): Promise<any> => {
    const context = canvas.getContext('2d');
    return new Promise(resolve => {
      const rectangleSvg = new Image();
      rectangleSvg.onload = () => {
        const widthPadding = w * 0.2;
        const heightPadding = h * 0.2;
        context.drawImage(
          rectangleSvg,
          x - widthPadding,
          y - heightPadding,
          w + widthPadding * 2,
          h + heightPadding * 2
        );
        resolve();
      };
      rectangleSvg.src = '/assets/images/crosshair.svg';
    });
  },

  drawWatermark: (
    canvas: HTMLCanvasElement,
    text: string,
    maxFontSize: number
  ) => {
    let fontSize = maxFontSize;
    const context = canvas.getContext('2d');
    context.textBaseline = 'middle';
    context.textAlign = 'center';
    context.fillStyle = 'rgba(255, 255, 255, 0.4)';
    // Fill the canvas with the watermark
    while (true) {
      context.font = `${fontSize}px monospace`;
      const { width } = context.measureText(text);
      if (width < canvas.width) {
        break;
      }
      fontSize -= 1;
    }
    context.fillText(text, canvas.width / 2, canvas.height / 2);
  },
};
